import type { AnimationConfigWithData, AnimationItem } from 'lottie-web'
import lottie from 'lottie-web'
import { useEffect, useRef } from 'react'
interface LottieProps {
  options: Omit<AnimationConfigWithData, 'container'>
  width?: number | string
  height?: number | string
}

/**
 * Tiny wrapper for playing Lottie animations for non complex use cases (replaces react-lottie).
 */
export const Lottie = ({ options, width, height }: LottieProps) => {
  const element = useRef<HTMLDivElement>(null)
  const lottieInstance = useRef<AnimationItem | null>(null)

  useEffect(() => {
    if (element.current) {
      lottieInstance.current = lottie.loadAnimation({
        ...options,
        container: element.current,
      })
    }

    return () => {
      lottieInstance.current?.destroy()
    }
  }, [options.animationData])

  return <div style={{ width, height }} ref={element} />
}

export default Lottie
